import React, { useEffect } from 'react';
import { useParams } from 'react-router';
import Header from './header/Header';
import ChatArea from './chatarea/ChatArea';
import StartView from './chatarea/StartView';
import useLanguage from '../../hooks/useLanguage';

// scss
import '../../scss/chatbot.scss';
import CommentBox from './chatarea/CommentBox';

const ChatBot = () => {
  const { lang } = useParams();
  const { setLanguage } = useLanguage();

  useEffect(() => {
    if (lang) {
      switch (lang.toLowerCase()) {
        case 'et':
          setLanguage('et');
          break;
        case 'ru':
          setLanguage('ru');
          break;
        case 'lv':
          setLanguage('lv');
          break;
        default:
          setLanguage('en');
      }
    }
  }, [lang]);

  useEffect(() => {
    const savedLanguage = localStorage.getItem('x-language');
    if(savedLanguage){
      setLanguage(savedLanguage);
    }
  }, []);

  return (
    <>
      <Header />
      <div id="content-wrapper">
        <StartView />
        <ChatArea />
      </div>

      <CommentBox/>
    </>
  );
};

export default ChatBot;
